import React from 'react';

// WordPress's own oEmbed template (`<slug>/embed/`) only renders the post
// EXCERPT inside a sandboxed iframe and deliberately skips loading the
// theme's/plugins' CSS+JS — so SmashBalloon's stylesheet never loads there
// no matter what runs the shortcode. Instead this points at the plain WP
// page itself, set to a header/footer-less template, so it's a normal full
// page load and SmashBalloon's assets enqueue exactly as they would anywhere
// else on the site.
//
// One-time setup required in wp-admin (not something this file can do):
//   1. Pages -> the "insta" page (or create one). Content: the exact
//      SmashBalloon shortcode already used elsewhere on the site (e.g.
//      `[instagram-feed feed=1]` -- check Instagram Feed -> All Feeds in
//      wp-admin for the right feed id).
//   2. In Page Attributes (right sidebar), set Template to Astra's
//      blank/canvas option (no header, no footer) so it doesn't render the
//      full site chrome inside this iframe.
//   3. Note the page's slug and set EMBED_URL below to
//      `https://raretto.com/<slug>/`.
const EMBED_URL = 'https://raretto.com/insta/';

const InstagramFeedEmbed = ({ className = '' }) => (
  <div className={className}>
    <iframe
      src={EMBED_URL}
      title="Raretto on Instagram"
      loading="lazy"
      className="w-full border-0"
      style={{ minHeight: 640 }}
    />
  </div>
);

export default InstagramFeedEmbed;
